//providers
import { useAppContext } from "providers/app"
import { useUsersDataContext } from "../providers/users"

//hooks
import useFetch from "hooks/useFetch"

//constants
import { ENDPOINTS } from "constants/endpoints.js"

function useRemoveUser(userId, removeUserRef) {
    const { fetch } = useFetch()

    const app = useAppContext()
    const users = useUsersDataContext()

    function handleRemove() {
        fetch({
            endpoint: `${ENDPOINTS.ADMIN.REMOVE_USER}/${userId}`,
            method: "delete",
        })
            .then(() => {
                users.refetchAllData()
                app
                    .handleMessage()
                    .success()
                    .show("Потребителят беше премахнат успешно!")
            })
            .catch(() => {
                app
                    .handleMessage()
                    .error()
                    .show("Нещо се обърка! Моля, опитайте отново.")
            })
            .finally(() => {
                removeUserRef.current.close()
            })
    }

    return {
        handleRemove
    }
}

export default useRemoveUser